import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import { Data } from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import {
  ISaleDiscountSummary,
  SaleDiscountSummary,
} from '../../../../model/discount-summary';
import { IDiscountSummaryApiService } from './discount-summary-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportDiscountSummaryQueryDto } from './dtos/export-discount-summary.query.dto';
import { FindDiscountSummaryQueryDto } from './dtos/find-discount-summary.query.dto';
import { FindDiscountSummaryResponseDto } from './dtos/find-discount-summary.response.dto';

@Injectable({
  providedIn: 'root',
})
export class DiscountSummaryMockApiService
  implements IDiscountSummaryApiService
{
  data = {
    discount_summaries: {
      items: [] as SaleDiscountSummary[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<ISaleDiscountSummary>,
      subject: new BehaviorSubject<Maybe<SaleDiscountSummary[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get discountSummariesData() {
    return this.data['discount_summaries'] as Data<
      SaleDiscountSummary,
      ISaleDiscountSummary
    >;
  }

  findDiscountSummary(query: FindDiscountSummaryQueryDto): Promise<FindDiscountSummaryResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportDiscountSummary(query: ExportDiscountSummaryQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
